import React, { useContext } from 'react';
import { FormattedHTMLMessage } from 'react-intl';
// Components
import { Image } from '../../Image/Image';
// Interfaces
import { IFormattedMessageProps } from '../../../interfaces/general.interfaces';
// Styles
import styles from './generalerror.module.scss';
import images from '../../../assets/images/images';
// Config
import { ConfigContext } from '../../../providers';

interface IGeneralErrorProps {
    messagePropsObjects: IFormattedMessageProps[];
    className?: string;
}

export const GeneralError = ({ className, messagePropsObjects }: IGeneralErrorProps): JSX.Element => {
    const config = useContext(ConfigContext);

    const shouldRenderGeneralError = messagePropsObjects?.length > 0;
    if (!shouldRenderGeneralError) {
        return null;
    }

    return (
        <div
            role="alert"
            className={`${styles.generalError} d-flex ${className}`}
            style={{ backgroundColor: config.colors.error.background }}
        >
            <Image className="align-self-start flex-shrink-0" src={images.modalError} alt="ERROR" />

            <div className="pl-3">
                {messagePropsObjects.map((props, index) => (
                    <p key={index} style={{ color: config.colors.error.color }}>
                        <FormattedHTMLMessage {...props} />
                    </p>
                ))}
            </div>
        </div>
    );
};
